module.exports = __webpack_public_path__ + "static/media/tipo2.518c7b38.png";